import { getJson, sendJson } from '@/lib/api';

/** An admin-managed kind of outside contact: client, venue, charity, DMC, AV… */
export interface ContactType {
  readonly _id: string;
  readonly key: string;
  readonly label: string;
  readonly isActive: boolean;
  readonly order: number;
}

/** Every contact type, in order. Seeds the defaults on first read. */
export async function listContactTypes(signal?: AbortSignal): Promise<readonly ContactType[]> {
  return getJson<ContactType[]>('/contact-types', undefined, signal);
}

/** Creates a type; the key comes from the label unless given. */
export async function createContactType(body: { label: string; key?: string; order?: number }): Promise<ContactType> {
  return sendJson<ContactType>('post', '/contact-types', body);
}

/** Renames, reorders or enables/disables a type. */
export async function updateContactType(id: string, body: { label?: string; order?: number; isActive?: boolean }): Promise<ContactType> {
  return sendJson<ContactType>('patch', `/contact-types/${id}`, body);
}

/** The label for a type key, falling back to the key itself. */
export function contactTypeLabel(types: readonly ContactType[] | undefined, key: string): string {
  return types?.find((type) => type.key === key)?.label ?? key;
}
